export default [
    {
        name: 'family',
        type: 'text-field',
        flex: {
            sm6: true,
            lg10: true,
        },
        props: {
            label: 'Nombre de Familia',
            // rules: [required],
        },
    },
]
